import _ from 'lodash'

export const orderSystemsGroupType = systems => {
  return _.mapValues(_.groupBy(systems, 'group'), system =>
    _.mapValues(_.groupBy(system, 'micaType'))
  )
}
